<div class="files-layout"
  [class.emptymessage-layout]="dataSource.length === 0 && !isLoading && showDeleted === 0 && !isReadOnly"
  appUploadDropBox [selectedFolder]="dropFolder" >
  <app-error
    *ngIf="errCode"
    [errcode]="errCode">
  </app-error>
  <sync-alert *ngIf="isPurgeEnabled() && showDeleted && dataSource.length >= 1"
    class="purge-alert" 
    type="promo"
    [showLeadIcon]="true"
    leadIcon="delete"
    title="Deleted items will be purged after {{this.purgeLimit}} days."
    description="{{showUpgradeMessage ? 'Upgrade your plan to get up to 365 days of data recovery.' : ''}}  "
    [showActions]="true"
    [showPrimaryAction]="true"
    [showSecondaryAction]="showUpgradeButton"
    [primaryButtonConfig]="{ label: 'Purge all', onClick: openPurgeAllDialog }"
    [secondaryButtonConfig]="{ label: 'Upgrade plan', onClick: redirectToUpgrade }"
    [showCloseButton]="false">
  </sync-alert>
  <div class="file-list" [class.grid-list]="isGridView">
    <sync-data-list [columns]="fileListColumns" [data]="dataSource"
      #dataList
      [scrollTop]="scrollTop"
      [allData]="fileList"
      [enableDnd]="true"
      [onDragStart]="onDragStart"
      [onDrop]="onDropped"
      [onDragOut]="onDragOut"
      [onDragOver]="onDragOver"
      [canDrop]="canDrop"
      [isSelectable]="true" [isInfoPanelEnabled]="true"
      [infoPanelTemplate]="infopanelcontent" [showBulkActions]="true"
      [emptyMessageTemplate]="emptyMessageTemplate"
      [bottomLoadMessageTemplate]="bottomLoadMessageTemplate"
      [bulkActionsLimit]="false"
      [bulkActions]="bulkActions" [showFilter]="true" [showInfoIcon]="true" [showGrid]="true"
      [searchConfig]="searchConfig" [showImageKey]="showImageKey" [tileSizeCondition]="tileSizeCondition"
      [lazyLoadingPaginationConfig]="lazyLoadingPaginationConfig" sortedColumnKey="name" [isSortAsc]="false" [sortConfig]="fileSorterConfig"
      [onRowClick]="onRowClick" [onRowDoubleClick]="onRowDoubleClick" [onCloseInfoPanel]="onCloseInfoPanel"
      [showInfoPanel]="openInfoPanel" [(clearSelection)]="clearSelectionValue" [isLoading]="isLoading"
      [droppableTemplate]="droppableArea"
      [filterIcons]="filterIcons"
      [showDimRow]="showDeleted === 1"
      [isCompactListItem]="true" [(selectedRows)]="selectedRows"
      [countText]="countText"
      [isSelectable]="true"
      [listViewBreakpoint]="$any(0)"
      [isStickyHeader]="true"
      [minusHeight]="currentMinusHeight"
      [infoPanelOffset]="145" enableVirtualization="scrollContainer"
      [headIcon$]="$any(headIcon$)"
      [onScrollContainerScroll]="onScroll"
      [dragEnterHandler]="dragEnter"
      [dragLeaveHandler]="onDragLeave"
      [dropHandler]="onDrop"
      >
    </sync-data-list>

    <div class="no-searchResult" *ngIf="dataSource.length === 0 && !isLoading && this.searchConfig.searchValue">
      <sync-icon [name]="'search'"></sync-icon>
      <span class="h4">No results found.</span>
      <span class="body-2">Change your filter criteria and try again.</span>
    </div>

    <!-- Info Panel Template -->
    <ng-template #infopanelcontent>
      <app-file-info [selectedRows]="selectedRows" [histId]="histId" [activeTab]="activeTab" [isDeleted]="showDeleted === 1"
        [fileListComponent]="this"></app-file-info>
    </ng-template>
  </div>
  <ng-template #bottomLoadMessageTemplate>
    <div *ngIf="dataSource.length > itemPerPage && dataSource.length === totalItems" class="loaded-all">
      <div class="caption">Loaded all {{totalItems}} items</div>
    </div>
  </ng-template>
  <ng-template #emptyMessageTemplate>
    <div class="empty-message-container" *ngIf="dataSource.length === 0 && !isLoading && showDeleted === 0 && !isReadOnly && !isVault&& !this.searchConfig.searchValue">
      <div class="visuals">
        <img src="assets/images/empty-file-list.png" alt="empty-image">
      </div>
      <div class="empty-message">
        <div class="h3 empty-message-text">Your secure cloud awaits!</div>
        <div class="body-1 empty-message-subtext">Begin uploading now for top-tier, safe storage of your precious files.
        </div>
      </div>
      <div class="upload">
        <app-upload-files [onUpload]="onUpload"></app-upload-files>
      </div>
      <sync-button label="Browse files" type="outlined" size="medium" [leadAdornment]="true" leadIconAdornment="upload"
        [onClick]="fabUploadOnClickXs"></sync-button>
    </div>
    <div class="empty-message-container" *ngIf="dataSource.length === 0 && !isLoading && showDeleted === 0 && isVault && !this.searchConfig.searchValue">
      <div class="visuals">
        <img src="assets/images/empty-vault.png" alt="empty-image">
      </div>
      <div class="empty-message">
        <div class="h3 large empty-message-text">Backup your files to the cloud by storing them in your Vault</div>
        <div class="body-1 empty-message-subtext">Vault is a cloud-only storage space for your backup files. Files added to Vault do not get synced to your other devices, allowing you to free up space and backup your local files to the cloud.
        </div>
        <div class="body-1 empty-message-subtext">
          <a class="vault-link" href="https://help.sync.com/hc/en-us/articles/38494244928659-What-is-the-Sync-Vault" target="_blank">Learn more about Vault</a>
        </div>
      </div>
      <div class="upload">
        <app-upload-files [onUpload]="onUpload"></app-upload-files>
      </div>
      <sync-button label="Browse files" type="outlined" size="medium" [leadAdornment]="true" leadIconAdornment="upload"
        [onClick]="fabUploadOnClickXs"></sync-button>
    </div>

    <div class="shared-empty-message-container" *ngIf="dataSource.length === 0 && !isLoading && showDeleted === 0 && isReadOnly && !this.searchConfig.searchValue">
      <div class="visuals">
        <img src="assets/images/empty-file-list.png" alt="empty-image">
      </div>
      <div class="empty-message">
        <div class="h3 empty-message-text">No items available</div>
        <div class="body-1 empty-message-subtext">This folder does not contain any files.</div>
      </div>
    </div>

    <div class="deleted-empty-message-container" *ngIf="dataSource.length === 0 && !isLoading && showDeleted === 1">
      <div class="empty-message">
        No deleted items in this folder.
      </div>
      <sync-button
          label="View active files"
          type="outlined"
          size="medium"
          [leadAdornment]="false"
          [onClick]="toggleDeleted"></sync-button>
    </div>
  </ng-template>
  <div class="fab-container" [ngStyle]="{'bottom.px': fabBottom}" *ngIf="!isReadOnly && !showDeleted">
    <div class="fab-buttons" *ngIf="isFabMenuOpen">
      <div class="fab-button">
        <sync-fab [extended]="true" [disabled]="false" [size]="'default'" [label]="'New file'"
          [leadAdornmentConfig]="{enabled: true, type: 'icon', size: 'large', iconName: 'file'}"
          [onClick]="fabFileOnClick" [displayLabelOnHover]="true"></sync-fab>
      </div>
      <div class="fab-button">
        <sync-fab [extended]="true" [disabled]="false" [size]="'default'" [label]="'New folder'"
          [leadAdornmentConfig]="{enabled: true, type: 'icon', size: 'large', iconName: 'folder-blank'}"
          [onClick]="fabFolderOnClick" [displayLabelOnHover]="true"></sync-fab>
      </div>
      <div class="fab-button hide-xs">
        <sync-fab [extended]="true" [disabled]="false" [size]="'default'" [label]="'Upload'"
          [leadAdornmentConfig]="{enabled: true, type: 'icon', size: 'large', iconName: 'upload'}"
          [onClick]="fabUploadOnClick" [displayLabelOnHover]="true"></sync-fab>
      </div>
      <div class="fab-button show-xs">
        <sync-fab [extended]="true" [disabled]="false" [size]="'default'" [label]="'Upload'"
          [leadAdornmentConfig]="{enabled: true, type: 'icon', size: 'large', iconName: 'upload'}"
          [onClick]="fabUploadOnClickXs" [displayLabelOnHover]="true"></sync-fab>
      </div>
    </div>
    <input type="file" multiple #fileInputFab (change)="fabUpload($event)" style="display: none;" />

    <sync-fab *ngIf="isFabMenuOpen" class="fab-close" [extended]="false" [disabled]="false" [size]="'default'"
      [leadAdornmentConfig]="{enabled: true, type: 'icon', size: 'large', iconName: 'close'}"
      [onClick]="fabClick"></sync-fab>
    <sync-fab *ngIf="!isFabMenuOpen" [extended]="false" [disabled]="false" [size]="'default'"
      [leadAdornmentConfig]="{enabled: true, type: 'icon', size: 'large', iconName: 'add'}"
      [onClick]="fabClick"></sync-fab>
  </div>
  <app-dialog-create-blank-document *ngIf="openCreateFileDialog"
    [(showDialog)]="openCreateFileDialog"></app-dialog-create-blank-document>
  <app-dialog-upload *ngIf="openUploadDialog" [(showDialog)]="openUploadDialog"></app-dialog-upload>

  <app-move-dialog
    *ngIf="isMoveDialogOpen"
    #moveDialog
    [(showMoveDialog)]="isMoveDialogOpen" 
    [selectedRows]="selectedRows"
    [actionMoveOrCopy]="actionMoveOrCopy"
    [defaultTab]="isVault ? 'Vault' : 'Files'"
    (showMoveDialogChange)="autoMove = false"
    [autoMove]="autoMove"
    [parentDir]="moveDialogParentDir">
  </app-move-dialog>
  <app-dialog-new-folder
    *ngIf="opennewFolderDialog"
    [(showDialog)]="opennewFolderDialog"
    [syncPid]="cwd.sync_id"
    [showFolderType]="hasPermission(permissionActions.SHARE_FOLDERS)"
    [isSharedFolder]="cwd.is_shared === 1"
    (folderCreated)="refreshList()"
  ></app-dialog-new-folder>
  <app-dialog-purge *ngIf="openDialogPurge" [(showDialog)]="openDialogPurge" [selectedFiles]="selectedRows"></app-dialog-purge>
  <app-dialog-restore *ngIf="openDialogRestore" [(showDialog)]="openDialogRestore" [selectedFiles]="selectedRows"></app-dialog-restore>
</div>

<ng-template #cellTemplate let-data="data">
  <div [class.droppable-row]="data.sync_id === dropFolder?.sync_id"></div>
  <div class="wrap-template" [class.grid-view]="isGridView"  [class.droppable-folder]="data.type === 'dir'">
    <div class="wrap-inner-text">
      <a (click)="$event.stopPropagation()" [routerLink]="getItemLink(data)" [queryParams]="getItemLinkQueryParams(data)" [matTooltip]="data.name"> 
        {{ data["name"] || "-" }}
      </a>
    </div>
    <div class="link-icon" *ngIf="!data.is_deleted">
      <sync-icon-button *ngIf="data['is_publink'] === 1" [matTooltip]="'Copy link'" [iconName]="'copy-link'" [type]="'default'"  [appCopyLink]="data" [size]="isGridView ? 'small' : 'large'"></sync-icon-button>
    </div>
  </div>
</ng-template>

<ng-template #iconTemplate let-data="data">
  <sync-icon *ngIf="!data[showImageKey]" [name]="fileIcon(data)" />
  <img class="row-thumb" *ngIf="data[showImageKey]" [src]="data[showImageKey]" />
</ng-template>


<app-dialog-rename *ngIf="isRename" [(isOpen)]="isRename" [Item]="Item"></app-dialog-rename>

<app-dialog-share-new *ngIf="openShareFolderDialog" [(showDialog)]="openShareFolderDialog"
  [selected]="selectedShareItem">
</app-dialog-share-new>

<app-dialog-delete *ngIf="openDeleteDialog" [(showDialog)]="openDeleteDialog" [selectedItems]="selectedRows" ></app-dialog-delete>


<ng-template #dialoglinkcontent>
  <app-dialog-link [item]="linkItem"></app-dialog-link>
</ng-template>

<app-dialog-share-details  *ngIf="openManageShareFolderDialog" [(showDialog)]="openManageShareFolderDialog" [selected]="selectedManageShareItem" [openState]="openManageShareFolderDialogOpenState"></app-dialog-share-details>
<ng-template #droppableArea>
  <div class="droppable">
    <div class="drop-message-container">
      <div class="drop-message">
        <sync-icon name="upload-to-cloud" size="large"></sync-icon>
        <div class="caption">Drop your file to upload it to</div>
        <div class="body-bold-2" *ngIf="!dropFolder?.name">{{cwd?.name}}</div>
        <div class="body-bold-2" *ngIf="dropFolder?.name">the folder named {{dropFolder?.name || cwd?.name}}</div>
      </div>
    </div>
  </div>
</ng-template>

<div *ngIf="draggedOver && !isSmScreen" class="drop-message-container">
  <div
    class="drop-message"
    [class.read-only]="draggedOver.is_readonly"
  >
    <sync-icon name="move-file-folder" size="large"></sync-icon>
    <div class="caption">Drop your items to move to</div>
    <div class="name body-bold-2">the folder named {{draggedOver.name}}</div>
  </div>
</div>

<sync-dialog
  [config]="{
    title: dndDialog.title,
    cancelButton: 'Close',
    onCancelClick: closeDndDialog,
  }"
  [open]="dndDialog.opened"
  [onClose]="closeDndDialog"
>
  <div class="dnd-dialog-body">{{dndDialog.message}}</div>
</sync-dialog>